import React from "react";
import "../styles/Pages.css";

function IAksharSpotify() {
  // Spotify artist ID for I Am Akshar
  const artistId = "7exaRUHjGMdwPUaZkvBJnb";

  return (
    <main className="page-content">
      <div className="page-header">
        <h1>I Am Akshar on Spotify</h1>
        <p className="header-subtitle">
          Listen to I Am Akshar's devotional songs and bhajans
        </p>
      </div>

      <div className="page-body">
        <div className="spotify-container">
          {/* Spotify Artist Embed */}
          <div className="spotify-section">
            <h2>Artist Profile</h2>
            <div className="spotify-embed">
              <iframe
                src={`https://open.spotify.com/embed/artist/${artistId}?utm_source=generator&theme=0`}
                width="100%"
                height="500"
                frameBorder="0"
                allowFullScreen=""
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="Spotify Artist"
              ></iframe>
            </div>
          </div>

          {/* External Link */}
          <div className="spotify-cta">
            <p>Listen to all I Am Akshar songs on Spotify</p>
            <a
              href="https://open.spotify.com/playlist/3Pz9Hjynomw4osfvOBChYn"
              target="_blank"
              rel="noopener noreferrer"
              className="spotify-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="24"
                height="24"
              >
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
              </svg>
              Open in Spotify
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}

export default IAksharSpotify;
